import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import {
  Dialog
} from '../../core';

import {
  ClientForm,
} from '../Clients';

import {
  setClientForm,
  startRemoveClient,
  startOnDoneClient,
  resetClientForm,
} from '../../../store/actions';

import icons from 'img/services';

const styles = theme => ({
  content: {
    maxWidth: "800px",
  },
});



const ServiceIconsDialog = (props) => {
  const {
    classes,
    show,
    handleClose,
    handleSelect,
  } = props;

  const iconStyle = {
    width: "50px",
    height: "50px",
    color: "grey"
  };

  const renderIcons = () => {
    return icons.toArray().map(icon => {
      if (icon.value["dark-48"]) {
        return(
          <Button onClick={() => handleSelect(icon.key)}>
            <img src={icon.value["dark-48"]} alt={icon.key} />
          </Button>
        )
      }
    });
  }

  return (
    <Dialog
      show={show}
      hideTitle
      hideActions
      title="Client"
      type={"edit"}
      onClose={() => {
        handleClose();
      }}
    >
      <div className={classes.content}>
        {renderIcons()}
      </div>
    </Dialog>
  );
};

const mapDispatchToProps = {
  setClientForm,
  startRemoveClient,
  startOnDoneClient,
  resetClientForm,
};

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(ServiceIconsDialog);



// WEBPACK FOOTER //
// ./src/components/admin/Dialogs/ServiceIconsDialog.jsx